// Public hook to fetch per-property testimonials. Falls back to the
// shared defaults baked into the backend if a property has no curated
// list yet.

import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const useTestimonials = (hotelSlug) => {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hotelSlug) {
      setItems([]);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    fetch(`${API}/api/testimonials/${encodeURIComponent(hotelSlug)}`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data) => {
        if (cancelled) return;
        setItems(Array.isArray(data.items) ? data.items : []);
      })
      .catch(() => {
        if (cancelled) return;
        setItems([]);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [hotelSlug]);

  return { items: items || [], loading };
};
